module.exports = __webpack_public_path__ + "static/images/smoothness/ui-bg_flat_0_aaaaaa_40x100.png";